module.exports = __webpack_public_path__ + "static/RESOURCES-a20301d168ab2d9e4ab5c1f9a99c0ac5.svg";